import Alpine from "alpinejs";
import { gsap } from "gsap";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

const navigationSetup = () => {
    Alpine.store('navSetup', {
        isOpen: false,
        currentSidebarTab: null,
        isSettingsPanelOpen: false,
        isSubHeaderOpen: false,
        hasScrolled: false,
        hideLogo: false,
        disableHideLogo: false,
        isLight: Alpine.$persist(true),
        scroller: null,
        tl: null,
        playing: false,
        initSmoothScroller(anim) {
           return  window.scroller = ScrollSmoother.create({
                wrapper: "#smooth-wrapper",
                content: "#smooth-content",
                target: "#smooth-content",
                smooth: 2,
                effects: anim,
                //smoothTouch: true,
                //normalizeScroll: true,
                onUpdate: (el) => {
                    Alpine.store('navSetup').scrolling(el);
                }
            });
        },
        scrollSmooth () {

            const width = window.innerWidth;
            window.tl = Alpine.store('navSetup').logoAnim();
            const scroller = Alpine.store('navSetup').initSmoothScroller((width > 768));

            setTimeout(() => {
               if(scroller.scrollTrigger.progress !== 0) {
                   Alpine.store('navSetup').hasScrolled = true;
               }
            }, 500);

            window.addEventListener("resize", () => {
                const width = window.innerWidth;
                if(width > 768){
                    if( !window.scroller.effects) {
                        console.log('turn on', window.scroller)
                        window.scroller.kill();
                        Alpine.store('navSetup').initSmoothScroller(true);
                    }
                    window.scroller.effects = true;
                } else {
                    if( window.scroller.effects) {
                        console.log('turn off', window.scroller)
                        window.scroller.kill();
                        Alpine.store('navSetup').initSmoothScroller(false);
                    }
                }
            });
        },
        logoAnim() {
            const icon = document.getElementById('icon');
            const tl = gsap.timeline({paused: true});
            if(icon) {
                const ease = "back.inOut(1.7)";
                const gap = "<15%";
                tl.from('#i-3', {duration: 1, scale: 0, transformOrigin: "100% 100%", ease: ease}, gap);
                tl.from('#i-1', {duration: 1, scale: 0, ease: ease}, gap);
                tl.from('#i-4', {duration: 1, scale: 0, transformOrigin: "0 100%", ease: ease}, gap);
                tl.from('#i-2', {duration: 1, scale: 0, transformOrigin: "100% 0", ease: ease}, gap);

                tl.timeScale(2);
                //tl.play()
            }
            return tl;
        },
        scrolling (el) {
            this.hasScrolled = (el.scrollTop() > 50 ? true : false)

            if(this.hasScrolled && window.tl) {
                if(this.playing) return
                this.playing = true
                console.log('play', this.playing);

                window.tl?.play(0, false);
            }

            if(!this.hasScrolled) {
                this.playing = false
            }

            if(!this.disableHideLogo) {

                if (this.hasScrolled) {
                    this.hideLogo = false;
                } else {
                    this.hideLogo = true;
                }

            }
        },
        toggle(){
            console.log(window.scroller);
            this.isOpen = !this.isOpen;
        }
    });
}

export default navigationSetup;
